<template>
  <div>
    <v-dialog v-model="show"
              v-if="renderedDelivery"
              transition="scale-transition"
              width="80%"
              persistent
    >
      <v-card>
        <v-card-title>
          <h2>Delivery Details</h2>
          <v-btn
            v-if="!viewingHistory"
            icon
            @click="$emit('close')"
            class="ml-auto"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider color="#42A5F5"></v-divider>

        <v-container container--fluid grid-list-sm class="pb-0">
          <v-row justify="center">
            <v-col cols="12" class="pb-0">
              <v-alert type="warning" @click.native="redirectHistoryDialog = true" :value="renderedDelivery.redirected">
                This delivery has been redirected.
              </v-alert>
              <v-alert type="warning" @click.native="rescheduleHistoryDialog = true" :value="renderedDelivery.rescheduled">
                This delivery has been rescheduled.
              </v-alert>
              <v-list cLass="pb-0">
                <v-container container--fluid grid-list-md pt-0 pb-0>
                  <v-row justify-left align="center">
                    <!--<v-col cols="6" tag="strong">{{info[key]}}</v-col>-->
                    <!--<v-col cols="6" class="text-xs-right">{{boxInfo[key]}}</v-col>-->
                    <!--<v-col cols="10">-->
                    <!--<v-divider></v-divider>-->
                    <!--</v-col>-->
                    <v-col cols="12" md="3" sm="6">
                      <v-list-item>
                        <v-list-item-action>
                          <v-icon color="blue darken-1">person</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-subtitle>Name</v-list-item-subtitle>
                          {{renderedDelivery.name}}<br>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>

                    <v-col cols="12" md="3" sm="6">
                      <v-list-item>
                        <v-list-item-action>
                          <v-icon color="blue darken-1">location_on</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-subtitle>Address</v-list-item-subtitle>
                          {{renderedDelivery.street1}}<br>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>

                    <v-col cols="12" md="3" sm="6">
                      <v-list-item>
                        <v-list-item-action>
                          <v-icon color="blue darken-1">location_on</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-subtitle>Suburb</v-list-item-subtitle>
                          {{renderedDelivery.suburb}}, {{renderedDelivery.state}}<br>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>

                    <v-col cols="12" md="3" sm="6">
                      <v-list-item>
                        <v-list-item-action>
                          <v-icon color="blue darken-1">location_on</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-subtitle>Postcode</v-list-item-subtitle>
                          {{renderedDelivery.postcode}}<br>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>

                  <v-row justify-left align="center">
                    <v-col cols="12" md="3" sm="6">
                      <v-list-item>
                        <v-list-item-action>
                          <v-icon v-if="renderedDelivery.status === 'Processed'" color="green">fiber_manual_record
                          </v-icon>
                          <v-icon v-else-if="renderedDelivery.status === 'Canceled'" color="red">fiber_manual_record
                          </v-icon>
                          <v-icon v-else-if="renderedDelivery.status === 'Pending'" color="orange">fiber_manual_record
                          </v-icon>
                          <v-icon v-else-if="renderedDelivery.status === 'On Hold'" color="orange">warning</v-icon>
                          <v-icon v-else>fiber_manual_record</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-subtitle>Status</v-list-item-subtitle>
                          <v-col cols="12" md="7" sm="6" class="select-status">
                            <v-select
                              v-model="renderedDelivery.status"
                              :items="statues"
                              :disabled="!(isInternalUser && isAdmin && (renderedDelivery.status === 'Pending' || renderedDelivery.status === 'On Hold'))"
                            ></v-select>
                          </v-col>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>

                    <v-col cols="12" md="3" sm="6">
                      <v-list-item>
                        <v-list-item-action>
                          <v-icon color="blue darken-1">note</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-subtitle>Reason Code</v-list-item-subtitle>
                          {{ this.$store.getters['fullNameReasonCode'](renderedDelivery.reason_code) }}
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>

                    <v-col cols="12" md="3" sm="6">
                      <v-list-item>
                        <v-list-item-action>
                          <v-icon color="blue darken-1">track_changes</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-subtitle>Tracking Number</v-list-item-subtitle>
                          {{ isInternalUser ? renderedDelivery.tracking + (renderedDelivery.version == 0 ? "" : "-" + renderedDelivery.version) : renderedDelivery.tracking }}<br>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>

                    <v-col cols="12" md="3" sm="6">
                      <v-list-item>
                        <v-list-item-action>
                          <v-icon color="blue darken-1">card_travel</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-subtitle>Invoice Number</v-list-item-subtitle>
                          {{renderedDelivery.invoice}}<br>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>

                  <v-row justify-left align="center">
                    <v-col cols="12" md="3" sm="6">
                      <v-list-item>
                        <v-list-item-action>
                          <v-icon color="blue darken-1">event_note</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-subtitle>Scheduled Date</v-list-item-subtitle>
                          {{renderedDelivery.date+'  '+renderedDelivery.time_window_slot}}<br>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>

                    <v-col cols="12" md="3" sm="6" v-if="renderedDelivery.status === 'Pending'">
                      <v-list-item>
                        <v-list-item-action>
                          <v-icon color="blue darken-1">access_time</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-subtitle>Estimated Time</v-list-item-subtitle>
                          {{renderedDelivery.estimated_time_updated}}<br>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="3" sm="6" v-else>
                      <v-list-item>
                        <v-list-item-action>
                          <v-icon color="blue darken-1">access_time</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-subtitle>Actual Time</v-list-item-subtitle>
                          {{renderedDelivery.actual_time}}<br>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>

                    <v-col cols="12" md="3" sm="6">
                      <v-list-item @click="tagsDialog=true">
                        <v-list-item-action>
                          <v-icon color="blue darken-1">fas fa-box</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-subtitle>Boxes</v-list-item-subtitle>
                            {{boxes}}<br>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>

                    <v-col cols="12" md="3" sm="6">
                      <v-btn v-if="!viewingHistory" text large color="amber darken-1" @click="getHistory">
                        History
                      </v-btn>
                      <v-btn v-else outlined large color="red" @click="backToHistory">
                        BACK
                      </v-btn>
                      <v-btn text large color="deep-purple" @click="getTransaction">
                        Transaction
                      </v-btn>
                      <v-btn text large color="primary" @click="getProperties" v-if="$store.getters['isDev']">
                        Properties
                      </v-btn>
                    </v-col>

                  </v-row>

                  <v-row justify-center>
<!--                    <v-col cols="12" :md="isInternalUser ? 3 : 5">-->
                    <v-col cols="12" :md="2">
                      <v-row class="ma-0 pa-0">
                        <h3>Delivery Instructions</h3>
                        <v-spacer></v-spacer>
<!--                        <v-btn text small-->
<!--                               @click="switchInstructionsEdit"-->
<!--                               :color="enableInstructionEditing?'':'primary'"-->
<!--                               v-if="$store.getters['isDev']"-->
<!--                               :disabel="renderedDelivery.status !== 'Pending'"-->
<!--                        >-->
<!--                          {{this.enableInstructionEditing ? 'Cancel' : 'Set'}}-->
<!--                        </v-btn>-->
<!--                        <v-btn text small @click="saveChanges" color="primary" v-if="enableInstructionEditing">-->
<!--                          Save-->
<!--                        </v-btn>-->
                      </v-row>
                      <v-textarea
                        v-model="renderedDelivery.instructions"
                        :disabled="!(isInternalUser && isAdmin && (renderedDelivery.status === 'Pending' || renderedDelivery.status === 'On Hold'))"
                        no-resize
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="2" v-if="isInternalUser">
                      <h3>Transaction notes</h3>
                      <v-textarea
                        v-model="renderedDelivery.transaction_notes"
                        disabled
                        no-resize
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="2" v-if="!renderedDelivery.follow_inst">
                      <h3>Delivery notes</h3>
                      <v-textarea
                        v-model="renderedDelivery.follow_inst_note"
                        disabled
                        no-resize
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" :md="isInternalUser ? 6 : 7">
                      <h3>SMS Settings</h3>
                      <v-row>
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="phone"
                            label="Phone Number"
                            :disabled="!editPermission"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4">
                          <v-switch
                            v-model="smsSwitch"
                            :disabled="!editPermission"
                            label="Send SMS"
                          ></v-switch>
                        </v-col>
                        <v-col cols="6" md="4">
                          <v-switch
                            v-model="smsOptOutSwitch"
                            :disabled="!editPermission"
                            label="SMS Opt Out"
                          ></v-switch>
                        </v-col>
                        <v-row>
                          <v-col cols="6">
                            <v-btn text block color="indigo lighten-3" @click="clearChanges">Reset</v-btn>
                          </v-col>
                          <v-col cols="6">
                            <v-btn text block color="blue darken-1" @click="saveChanges">Save</v-btn>
                          </v-col>
                        </v-row>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row justify="center">
                    <v-col cols="12">
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>

                  &nbsp

                  <section v-if="viewErrorPermission && renderedErrors.length > 0">
                    <h1>Errors</h1>
                    <v-data-table
                      v-if="renderedErrors.length > 0"
                      :items="renderedErrors"
                      :headers="tableHeaders"
                    >
                      <template v-slot:item="props">
                        <tr>
                          <td style="text-align: center" v-for="(header, index) in tableHeaders" :key="index">
                            {{props.item[header.value]}}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </section>

                </v-container>
              </v-list>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col cols="6" class="text-center">
              <v-btn
                class="white--text"
                color="orange"
                text
                @click="smsDialog = true"
                :disabled="renderedDelivery.sms_messages.length === 0"
              >
                <v-icon class="pr-2">fas fa-envelope</v-icon>
                SMS Info
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

        <v-container container--fluid grid-list-lg class="pt-0 pb-0">
          <v-row justify="center" v-if="!alertMap">
            <v-col md="10" cols="12">
              <GmapMap
                :center="{lat: renderedDelivery.actual_latitude, lng: renderedDelivery.actual_longitude}"
                :zoom="11"
                map-type-id="terrain"
                style="height: 300px; width: 100%"
              >
                <GmapMarker
                  v-if="renderedDelivery.actual_latitude"
                  :position="{lat: renderedDelivery.actual_latitude, lng: renderedDelivery.actual_longitude}"
                  :clickable="true"
                  @click="center={lat: renderedDelivery.actual_latitude, lng: renderedDelivery.actual_longitude}"
                />
                <GmapMarker
                  v-else
                  :position="{lat: renderedDelivery.site_latitude, lng: renderedDelivery.site_longitude}"
                  :clickable="true"
                  @click="center={lat: renderedDelivery.site_latitude, lng: renderedDelivery.site_longitude}"
                />
              </GmapMap>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col cols="6">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" class="text-center display-1 raleway-bold"
                   v-if="renderedDelivery.status === 'Processed'">
              POD
              <v-btn text small color="blue darken-1">
                <v-icon @click="downloadPOD">fas fa-download</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="10">
              <v-row justify="center">
                <v-col v-for="(image, index) in renderedDelivery.images" :key="index">
                  <v-container>
                    <v-img class="delivery-image"
                           :src="image.url"
                           contain
                    ></v-img>
                    <span class="signBy" v-show="image.type === 'Signature'">
                    {{"Signed By: " + renderedDelivery.signed_by}}</span>
                  </v-container>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row justify="center" v-if="editErrorPermission" :class="{'justify-flex-around': $vuetify.breakpoint.smAndDown}">
            <v-col cols="2" class="text-center">
              <FlagErrorDialog
                v-on:error-flagged="errorFlagged"
                :tracking="renderedDelivery.tracking">
              </FlagErrorDialog>
            </v-col>
            <v-col cols="2" class="text-center">
              <DeleteErrorDialog
                :disabled="renderedErrors.length === 0"
                :tracking="renderedDelivery.tracking"
                v-on:error-deleted="errorFlagged">
              </DeleteErrorDialog>
            </v-col>
          </v-row>
        </v-container>

        <v-footer dark v-if="alertMap" color="#64b0d7" class="justify-center">
          Sorry we couldn't display the map as the geocodes of this delivery were not found
        </v-footer>

        <v-card
          v-show="canRedirectReschedule"
          color="red lighten-3"
          style="height: 150px; margin-top: -5px; padding-top: -10px;color: white; "
        >
          <v-row class="fill-height" align="center" justify="center">
            <v-col cols="12" md="12" lg="6">
              <div class="text-h6 font-weight-bold">
                Changes cannot be made to this delivery. The cutoff has passed.
              </div>

              <div>
                Delivery date {{ renderedCutoff.date }} from the dispatch depot {{ renderedCutoff.depot_name }}
                has a cutoff <br>
                {{ renderedCutoff.insert_cutoff }}
                ({{ renderedCutoff.cutoff_timezone }}) <br>
                Available functions are highlighted below.
              </div>

              <div v-show="isAdmin && canRedirectReschedule" class="mt-2">
                <strong>IMPORTANT!! Your administrator access allows you to override this cutoff.</strong>
              </div>
            </v-col>
          </v-row>
        </v-card>


        <v-card-actions v-if="((isAdmin && renderedDelivery.status !== 'Processed') || (!isAdmin && renderedDelivery.status !== 'Canceled')) && !isTrackingErrors">
          <v-container grid-list-sm class="pt-0">
            <v-row justify="center" align="center" v-if="isAdmin || redirectPermission || reschedulePermission">
              <v-col cols="12" md="6" class="text-center" v-if="isAdmin || (redirectPermission && !isTerminalState)">
                <v-btn text :loading="loading" color="indigo" @click="addressChange=true" :disabled="!renderedCutoff.canRedirect && !isAdmin">
<!--                <v-btn text :loading="loading" color="indigo" @click="addressChange=true" >-->
                  <v-icon class="mr-2">forward</v-icon>
                  Redirect Delivery
                </v-btn>
              </v-col>
              <v-col cols="12" md="6" class="text-center" v-if="isAdmin || reschedulePermission">
                <v-btn text :loading="loading" color="blue lighten-2" @click="timeChange=true"  :disabled="!renderedCutoff.canReschedule && !isAdmin">
<!--                <v-btn text :loading="loading" color="blue lighten-2" @click="timeChange=true" >-->
                  <v-icon class="mr-2">schedule</v-icon>
                  Reschedule Delivery
                </v-btn>
              </v-col>
            </v-row>
            <v-row justify="center" align="center" v-if="cancelPermission || deletePermission">
              <v-col cols="12" md="6" class="text-center" v-if="cancelPermission">
                <v-btn text :loading="loading" color="red" @click="cancel=true" :disabled="!renderedCutoff.canCancel && !isAdmin"  >
<!--                <v-btn text :loading="loading" color="red" @click="cancel=true" >-->
                  <v-icon class="mr-2 pb-1">fas fa-ban</v-icon>
                  Cancel Delivery
                </v-btn>
              </v-col>
              <v-col cols="12" md="6" class="text-center" v-if="deletePermission">
                <v-btn text :loading="loading" color="red" @click="deleteDialog=true"   :disabled="!renderedCutoff.canInsert && !isAdmin">
<!--                <v-btn text :loading="loading" color="red" @click="deleteDialog=true"  >-->
                  <v-icon class="mr-2">fas fa-trash</v-icon>
                  Delete Delivery
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>

        <v-card-actions v-else-if="isTrackingErrors">

          <v-container v-if="viewingHistory" grid-list-sm class="pt-0">
            <v-row justify="center" align="center" v-if="redirectPermission || reschedulePermission">
              <v-col cols="12" md="6" class="text-center" v-if="isAdmin || (redirectPermission && !isTerminalState)">
                <v-btn text :loading="loading" color="indigo" @click="addressChange=true"   :disabled="!renderedCutoff.canRedirect && !isAdmin" >
<!--                <v-btn text :loading="loading" color="indigo" @click="addressChange=true"  >-->
                  <v-icon class="mr-2">forward</v-icon>
                  Redirect Delivery
                </v-btn>
              </v-col>
              <v-col cols="12" md="6" class="text-center" v-if="isAdmin || reschedulePermission">
                <v-btn text :loading="loading" color="blue lighten-2" @click="timeChange=true" :disabled="!renderedCutoff.canReschedule && !isAdmin">
<!--                <v-btn text :loading="loading" color="blue lighten-2" @click="timeChange=true" >-->
                  <v-icon class="mr-2">schedule</v-icon>
                  Reschedule Delivery
                </v-btn>
              </v-col>
            </v-row>
            <v-row justify="center" align="center" v-if="cancelPermission || deletePermission">
              <v-col cols="12" md="6" class="text-center" v-if="cancelPermission">
                <v-btn text :loading="loading" color="red" @click="cancel=true" :disabled="!renderedCutoff.canCancel && !isAdmin">
<!--                <v-btn text :loading="loading" color="red" @click="cancel=true">-->
                  <v-icon class="mr-2 pb-1">fas fa-ban</v-icon>
                  Cancel Delivery
                </v-btn>
              </v-col>
              <v-col cols="12" md="6" class="text-center" v-if="deletePermission">
                <v-btn text :loading="loading" color="red" @click="deleteDialog=true"  :disabled="!renderedCutoff.canInsert && !isAdmin">
<!--                <v-btn text :loading="loading" color="red" @click="deleteDialog=true"  >-->
                  <v-icon class="mr-2">fas fa-trash</v-icon>
                  Delete Delivery
                </v-btn>
              </v-col>
            </v-row>
          </v-container>

          <v-container v-else grid-list-sm class="pt-0">
            <v-row justify="space-around">
              <v-col cols="3" class="text-center">
                <v-btn text block color="red" @click="trackingError('deny')">
                  DENY
                </v-btn>
              </v-col>

              <v-col cols="3" class="text-center">
                <v-btn text block color="green" @click="trackingError('approve')">
                  APPROVE
                </v-btn>
              </v-col>
            </v-row>

          </v-container>

        </v-card-actions>

      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
      v-if="deletePermission"
    >
      <v-card>
        <v-card-title class="justify-center">
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text class="text-center">
          You are about to delete your delivery.<br>
          This action cannot be undone.
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="deleteDialog=false">Cancel Deletion</v-btn>
          <v-btn text color="red" @click="deleteDelivery">Delete Delivery</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DeliveryCancelDialog
      v-if="cancelPermission"
      :tracking="tracking"
      :showProp="cancel"
      v-on:close="cancel=false"
      :loading="loading"
      @changeLoading="changeLoading"
    ></DeliveryCancelDialog>


    <DeliveryRescheduleDialog
      v-if="renderedDelivery && reschedulePermission"
      :tracking="tracking"
      :delivery="renderedDelivery"
      :region_id="renderedDelivery.region_id"
      :showProp="timeChange"
      v-on:close="timeChange=false"
      :loading="loading"
      @changeLoading="changeLoading"
    ></DeliveryRescheduleDialog>

    <DeliveryRedirectDialog
      v-if="renderedDelivery && redirectPermission"
      :tracking="tracking"
      :delivery="renderedDelivery"
      :showProp="addressChange"
      v-on:close="addressChange=false"
      :loading="loading"
      @changeLoading="changeLoading"
    ></DeliveryRedirectDialog>






    <RedirectHistoryDialog
      v-if="renderedDelivery && redirectHistoryDialog"
      :delivery="renderedDelivery"
      :showProp="redirectHistoryDialog"
      v-on:close="redirectHistoryDialog=false"
    ></RedirectHistoryDialog>

    <RescheduleHistoryDialog
      v-if="renderedDelivery && rescheduleHistoryDialog"
      :delivery="renderedDelivery"
      :showProp="rescheduleHistoryDialog"
      v-on:close="rescheduleHistoryDialog=false"
    ></RescheduleHistoryDialog>

    <TagsDialog
      v-if="renderedDelivery && tagsDialog"
      :tags="renderedDelivery.tags"
      :showProp="tagsDialog"
      v-on:close="tagsDialog=false"
    ></TagsDialog>

    <v-dialog v-model="smsDialog" width="500px" v-if="renderedDelivery">
      <v-card>
        <v-card-title>
          <h2>SMS Information</h2>
          <v-spacer></v-spacer>
          <v-btn icon @click="smsDialog=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
        <v-card-text>
          <v-row justify="center">
            <v-col cols="12" md="10">
              <v-container container--fluid grid-list-lg v-for="(sms, index) in renderedDelivery.sms_messages"
                           :key="index">
                <h3 class="text-center raleway-bold">
                  SMS {{index + 1}}
                </h3>
                &nbsp
                <v-row justify="center" align="center" v-for="(field, infoIndex) in Object.keys(smsInfo)"
                       :key="infoIndex">
                  <v-col cols="5" tag="strong">
                    {{smsInfo[field]}}
                  </v-col>
                  <v-col cols="7" class="text-right">
                    {{sms[field]}}
                  </v-col>
                  <v-col cols="6">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="historyDialog" width="1100px" v-if="history" persistent>
      <v-card>
        <v-card-title>
          <h2 v-if="isInternalUser">History for site {{this.delivery.site_number}}</h2>
          <h2 v-else>History</h2>
          <v-spacer></v-spacer>
          <v-btn icon @click="historyDialog=false; viewingHistory=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
        <v-card-text class="px-0">
          <v-row justify="center" no-gutters>
            <v-col cols="12">
              <v-data-table
                :headers="headerHistory"
                :items="history"
              >
                <template v-slot:item="props">
                  <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}" class="cursor">
                    <td style="text-align: center" v-for="(header, index) in headerHistory"
                        :key="index" @click="seeHistoryDisplayer(props.item)">{{props.item[header.value]}}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-subheader>Picture history</v-subheader>
        <v-container fluid>
          <v-row>
            <v-col v-for="(item, index) in history" :key="index" cols="4">
              <v-carousel height="30vw" hide-delimiter-background>
                <v-carousel-item
                  v-for="(image, i) in item.images"
                  :key="i"
                  style="background-color: #42424211"
                >
                  <v-img
                    :src="image.url"
                    contain
                    class="image"
                    alt="lorem"
                    width="100%"
                    height="100%"
                  ></v-img>
                </v-carousel-item>
              </v-carousel>
              <v-col cols="12" class="text-center">
                <p>
                  <span style="color: #1357a4">Time:</span>
                  {{item.estimated_time}}
                </p>
              </v-col>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="transactionDialog" width="2200px" v-if="transaction">
      <v-card>
        <v-card-title>
          <h2>Transaction detail</h2>
          <v-spacer></v-spacer>
          <h2 class="mr-8" style="color: #BDBDBD; font-size: smaller">
            Tracking Number: {{renderedDelivery.tracking}}
          </h2>
          <v-btn icon @click="transactionDialog=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
        <v-card-text class="px-0">
          <v-row justify="center" no-gutters>
            <v-col cols="12">
              <v-data-table
                :headers="headerTransaction"
                :items="transaction"
              >
                <template v-slot:item="props">
                  <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}" class="cursor">
                    <td v-if="header.value !== 'coordinates'" style="text-align: center" v-for="(header, index) in headerTransaction"
                        :key="index" >{{props.item[header.value]}}
                    </td>
                    <td v-else style="text-align: center" >
                      <a target="_blank" :href="props.item['coordUrl']">{{props.item['coordinates']}}</a>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
<!--        <v-card-text class="px-0">-->
<!--          <v-row no-gutters>-->
<!--            <v-col cols="12" md="2" sm="6" v-for="(header, index) in headerTransaction" :key="'transaction_' + index" v-if="header.internOnly ? isInternalUser : true">-->
<!--              <v-list-item>-->
<!--                <v-list-item-content>-->
<!--                  <v-list-item-subtitle>{{header.text}}</v-list-item-subtitle>-->
<!--                  {{transaction[0][header.value] ? transaction[0][header.value] : 'no data'}}-->
<!--                </v-list-item-content>-->
<!--              </v-list-item>-->
<!--            </v-col>-->
<!--            <v-col cols="12" md="2" sm="6">-->
<!--              <v-list-item>-->
<!--                <v-list-item-content>-->
<!--                  <v-list-item-subtitle>Coordinates</v-list-item-subtitle>-->
<!--                  <a :href="'http://www.google.com/maps/place/'+transaction[0]['lat']+','+transaction[0]['lon']" target="_blank">-->
<!--                    {{transaction[0]['lat'] + '/' + transaction[0]['lon']}}-->
<!--                  </a>-->
<!--                </v-list-item-content>-->
<!--              </v-list-item>-->
<!--            </v-col>-->
<!--          </v-row>-->
<!--        </v-card-text>-->
      </v-card>
    </v-dialog>

    <PropertiesDialog
      v-if="renderedDelivery && propertiesDialog"
      :show-dialog="propertiesDialog"
      :delivery="renderedDelivery"
      v-on:close="propertiesDialog=false"
    ></PropertiesDialog>


  </div>
</template>

<script>
    import axios from 'axios'
    import FlagErrorDialog from "./FlagErrorDialog";
    import DeleteErrorDialog from "./DeleteErrorDialog";
    import DeliveryCancelDialog from "./DeliveryCancelDialog";
    import DeliveryRescheduleDialog from "./DeliveryRescheduleDialog";
    import DeliveryRedirectDialog from "./DeliveryRedirectDialog";
    import RedirectHistoryDialog from "./RedirectHistoryDialog";
    import RescheduleHistoryDialog from "./RescheduleHistoryDialog";
    import TagsDialog from "./TagsDialog";
    import PropertiesDialog from "./PropertiesDialog";
    // @vuese
    // Dialog displaying the information relative to a particular delivery the user previously clicked on
    // @group Search
    export default {
        name: "DeliveryInfoDisplayer",
        components: {
            TagsDialog,
            RescheduleHistoryDialog,
            RedirectHistoryDialog,
            DeleteErrorDialog,
            FlagErrorDialog,
            DeliveryCancelDialog,
            DeliveryRescheduleDialog,
            DeliveryRedirectDialog,
            PropertiesDialog,
        },
        props: {
            tracking: String,
            showProp: Boolean,
            isTrackingErrors: Boolean,
        },
        data() {
            return {
                reload: false,
                cancel: false,
                timeChange: false,
                addressChange: false,
                tagsDialog: false,
                tableHeaders: [
                    {text: 'Source', value: 'source', align: 'center', sortable: false},
                    {text: 'Verified', value: 'verified', align: 'center', sortable: false},
                    {text: 'Code', value: 'code_source', align: 'center', sortable: false},
                    {text: 'Note', value: 'notes', align: 'center', sortable: false},
                ],
                smsInfo: {
                    type: 'Type:',
                    time: 'Time:',
                    status: 'Status:',
                    message: 'Message:'
                },
                timeWindows: [],
                newTimeWindow: null,
                isDevelopment: process.env.NODE_ENV === 'development',
                smsDialog: false,
                deleteDialog: false,
                smsOptOutSwitch: false,
                smsSwitch: false,
                phone: null,
                deliveryInstructions: null,
                enableInstructionEditing: false,
                redirectHistoryDialog: false,
                rescheduleHistoryDialog: false,
                loading: false,
                historyTracking: null,
                history: null,
                historyDialog: false,
                propertiesDialog: false,
                viewingHistory: false,
                transaction: null,
                transactionDialog: false,
                rescheduleDialog:false,
                redirectDialog:false,
                boxes:0,
                statues:["On Hold"],
            }
        },
        methods: {
            clearChanges() {
                this.deliveryInstructions = this.delivery.instructions;
                this.phone = this.delivery.phone1;
                this.smsSwitch = this.delivery.sms;
                this.smsOptOutSwitch = this.delivery.sms_opt_out;
            },
            getTimeWindows(start,end){
              let res = '';
              if(start === null || end === null){
                return res;
              } else {
                start = start.split(' ')[1];
                start = start.substring(0,start.lastIndexOf(':'));
                end = end.split(' ')[1];
                end = end.substring(0,end.lastIndexOf(':'));
                res = start + '--' + end;
              }
             return res;
            },
            saveChanges() {
                let data = {
                    sms: this.smsSwitch,
                    sms_opt_out: this.smsOptOutSwitch,
                    phone1: this.phone,
                    instructions: this.deliveryInstructions,
                    type:this.renderedDelivery.status
                };
                axios.put(process.env.API_URL + '/deliveries/' + this.renderedDelivery.tracking, data)
                    .then((response) => {
                        this.reload = !this.reload;
                        this.$store.commit('displaySnackbar', 'Successfully updated delivery settings');
                    })
                    .catch((error) => {
                        alert('Failed to update delivery settings');
                    });
            },
            toggleSmsOptOut() {
                axios.put(process.env.API_URL + '/deliveries/' + this.renderedDelivery.tracking, {sms_opt_out: this.smsOptOutSwitch})
                    .then((response) => {
                        this.$store.commit('displaySnackbar', 'Successfully turned SMS opt out ' + (this.smsOptOutSwitch ? 'on' : 'off'));
                    })
                    .catch((error) => {
                        alert('Failed to change SMS opt out');
                        this.smsOptOutSwitch = !this.smsOptOutSwitch;
                    });
            },
            // @vuese
            // Displays a message when an error has been flagged by the user and closes the delivery info dialog.
            // @arg Takes a string message as an argument to display it in a snackbar.
            errorFlagged(message) {
                this.$store.commit('displaySnackbar', message);
                // this.toggleInfoDisplayer();
            },
            // @vuese
            // Gets Proof of delivery from a particular delivery from the API and downloads it.
            downloadPOD() {
                window.open(process.env.API_URL + '/deliveries/' + this.renderedDelivery.tracking + '/pod?key=' + encodeURI(this.$store.state.auth.key), '_blank')
            },
            // @vuese
            // Deletes delivery and posts the changes on the API.
            deleteDelivery() {
                this.loading = true;
                this.$store.commit('displayWaitDialog', true);
                let body = {code: 'DEL', note: ''};
                axios.delete(process.env.API_URL + '/deliveries/' + this.renderedDelivery.tracking, {data: body})
                    .then((response) => {
                        this.$store.commit('displaySnackbar', 'You deleted the delivery ' + this.renderedDelivery.tracking + ' successfully.');
                        // this.$emit('delete-delivery', this.renderedDelivery);
                        this.deleteDialog = false;
                        this.show = false;
                        this.loading = false;
                        this.$store.commit('displayWaitDialog', false);

                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        this.deleteDialog = false;
                        this.loading = false;
                        this.$store.commit('displayWaitDialog', false);
                    });
            },
            changeLoading(state){
                this.loading = state;
            },
            getHistory(){
              axios.get(process.env.API_URL + '/sites/' + this.delivery.site_id + '/deliveries')
                  .then((response) => {
                      this.history = response.data.reverse();
                      this.historyDialog = true;
                  })
                  .catch((response) => {
                      this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                  })
            },
          getProperties(){
              this.propertiesDialog = true
          },
          seeHistoryDisplayer(historyItem){
              this.viewingHistory = true;
              this.historyDialog = false;
              this.historyTracking = historyItem.tracking;
              this.$emit('displayShowDialog');
          },
          backToHistory(){
              this.historyTracking = null;
              this.viewingHistory = false;
              this.$emit('displayShowDialog');
              this.historyDialog = true;
          },
          getTransaction(){
            axios.get(process.env.API_URL + '/deliveries/' + this.renderedDelivery.tracking + '/transactions')
              .then((response) => {
                this.transaction = response.data;
                if (this.transaction.length === 0){
                  this.$store.commit('displaySnackbar', 'No transactions for this tracking number');
                }
                this.transaction.filter((transaction) => {
                  transaction.coordinates = transaction['lat'] + ',' + transaction['lon'];
                  if(transaction['lat'] === 0 || transaction['lon'] === 0){
                    transaction['lat'] = null;
                    transaction['lon'] = null;
                  }
                  transaction.coordUrl = 'https://maps.google.com.au?q=' + transaction['lat'] + ',' + transaction['lon'];

                });
                this.transactionDialog = true;
              })
              .catch((response) => {
                this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
              })
          },
            trackingError(btnAction){
                if (this.isErrorEditUser){
                    this.$emit('close');
                    if (btnAction === 'approve'){
                        this.$emit('approving');
                    } else {
                        this.$emit('denying');
                    }
                } else {
                    this.$store.commit('displaySnackbar', 'You don\'t have the right permission to do this action');
                }
            },
            switchInstructionsEdit(){
              if (this.enableInstructionEditing){
                this.deliveryInstructions = this.delivery.instructions;
              }
              this.enableInstructionEditing = !this.enableInstructionEditing
            },
            saveInstructions(){

            }
        },
        computed: {
            show: {
                get() {
                    return this.showProp;
                },
                set(value) {
                    if (!value) this.$emit('close');
                }
            },
            isInternalUser() {
                return this.$store.getters['auth/isInternalUser'];
            },
            isAdmin() {
                return this.$store.getters['auth/isAdmin'] || this.$store.getters['auth/hasPermission']('delivery_admin');
            },
            canRedirectReschedule(){
              if (!this.renderedCutoff.use_run_cutoffs) return false;
              else return !(this.renderedCutoff.canInsert && this.renderedCutoff.canCancel
                  && this.renderedCutoff.canRedirect && this.renderedCutoff.canReschedule);
            },
            renderedDelivery() {
                if (this.delivery === undefined || this.delivery === null) return null;
                this.delivery['time_window_slot'] = this.getTimeWindows(this.delivery['time_window_start'],this.delivery['time_window_end']);
                this.boxes = 0;
                if(this.delivery.tags.length > 0){
                  this.delivery.tags.forEach((tag) => {
                    if(tag.transaction === 'delivery'){
                      this.boxes = this.boxes + tag.quantity;
                    }
                  });
                }
                this.statues.unshift(this.delivery.status);
                this.clearChanges();
                return this.delivery;
            },
            // @vuese
            // Returns an array of errors to be displayed filtered by non deleted errors.
            renderedErrors() {
                let errors = [];
                if (this.renderedDelivery.errors !== null) {
                    errors = this.renderedDelivery.errors;
                    errors = errors.filter((elt) => {
                        return !elt.deleted
                    });
                }
                return errors
            },
            renderedCutoff() {
              if (this.getRunCutoffs === undefined || this.getRunCutoffs === null) return [];
              else return this.getRunCutoffs;
            },
            // Returns false if either site_latitude or site_longitude  AND actual_latitude or actual_longitude is not given by the API on this delivery.
            alertMap() {
                return (
                  ((this.renderedDelivery.site_latitude === null || this.renderedDelivery.site_latitude === undefined) ||
                    (this.renderedDelivery.site_longitude === null || this.renderedDelivery.site_longitude === undefined)) &&
                  ((this.renderedDelivery.actual_latitude === null || this.renderedDelivery.actual_latitude === undefined) ||
                    (this.renderedDelivery.actual_longitude === null || this.renderedDelivery.actual_longitude === undefined))
                )
            },
            cancelPermission() {
                if (this.delivery === null) return false;
                return this.$store.getters['auth/hasPermissionRegionId']('delivery_cancel', this.renderedDelivery.region_id);
            },
            deletePermission() {
                if (this.delivery === null) return false;
                return this.$store.getters['auth/hasPermissionRegionId']('delivery_delete', this.renderedDelivery.region_id);
            },
            editPermission() {
                if (this.delivery === null) return false;
                return this.$store.getters['auth/hasPermissionRegionId']('delivery_edit', this.renderedDelivery.region_id);
            },
            redirectPermission() {
                if (this.delivery === null) return false;
                return this.$store.getters['auth/hasPermissionRegionId']('delivery_redirect', this.renderedDelivery.region_id);
            },
            reschedulePermission() {
                if (this.delivery === null) return false;
                return this.$store.getters['auth/hasPermissionRegionId']('delivery_reschedule', this.renderedDelivery.region_id);
            },
            viewErrorPermission() {
                if (this.delivery === null) return false;
                return this.$store.getters['auth/hasPermissionRegionId']('error_view', this.renderedDelivery.region_id);
            },
            editErrorPermission() {
                if (this.delivery === null) return false;
                return this.$store.getters['auth/hasPermissionRegionId']('error_edit', this.renderedDelivery.region_id);
            },
            isTerminalState() {
                if (this.delivery === null) return false;
                return ["Processed", "Canceled", "Cancelled", "Processed Offline"].includes(this.renderedDelivery.status);
            },
            isErrorEditUser(){
                return this.$store.getters['auth/hasPermission']('error_edit')
            },
            headerHistory() {
                let headers = [
                    {text: 'Name', value: 'name', align: 'center'},
                    {text: 'Address', value: 'street1', align: 'center'},
                    {text: 'Region', value: 'region_name', align: 'center'},
                    {text: 'Invoice No', value: 'invoice', align: 'center'},
                    {text: 'Tracking Id', value: 'tracking', align: 'center'},
                    {text: 'Date', value: 'date', align: 'center', sortable: true},
                    {text: 'Status', value: 'status', align: 'center'},
                    {text: 'Actual Time', value: 'actual_time', align: 'center'},
                ];

                if (this.isInternalUser) {
                    headers.unshift({text: 'Client Name', value: 'client_name', align: 'center'});
                }

                return headers;
            },
          headerTransaction(){
            let headers = [
              {text: 'ID', value: 'id', align: 'center', sortable: false},
              {text: 'Type', value: 'type', align: 'center', sortable: false},
              {text: 'Reason Code', value: 'reason_code', align: 'center', sortable: false},
              {text: 'Time', value: 'time_iso', align: 'center', sortable: false},
              {text: 'Coordinates', value: 'coordinates', align: 'center', sortable: false}
            ];
            if (this.isInternalUser) {
              headers.push(
                {text: 'Out of Range', value: 'out_of_range', align: 'center', sortable: false},
                {text: 'Notes', value: 'notes', align: 'center', sortable: false},
                {text: 'Route Name', value: 'route', align: 'center', sortable: false},
                {text: 'Driver Name', value: 'driver_name', align: 'center', sortable: false},
                {text: 'Contractor', value: 'contractor_name', align: 'center', sortable: false},
                {text: 'Contractor Email', value: 'contractor_email', align: 'center', sortable: false},
                {text: 'Stop Sequence', value: 'stop_sequence', align: 'center', sortable: false},
                {text: 'Stop Version', value: 'version', align: 'center', sortable: false});
            }
            return headers;
          }
        },
        asyncComputed: {
            async delivery() {
              if (this.reload || !this.reload){
                let tracking = (this.historyTracking == null ? this.tracking : this.historyTracking);
                if (tracking === undefined || tracking === null) return null;
                return await axios.get(process.env.API_URL + '/deliveries/' + tracking)
                  .then((response) => {
                    return response.data;
                  })
                  .catch((err) => {
                    this.$store.commit('displaySnackbar', 'ERROR: ' + (err.response === undefined ? 'Unknown error' : err.response.data.error));
                    this.show = false;
                  })
              }
            },
            async getRunCutoffs() {
                if (this.tracking === null || this.tracking === undefined) return null;
                return await axios.get(process.env.API_URL + '/runs/cutoffs/' + this.tracking)
                  .then((response) => {
                    const cutoff = response.data[0];
                    if (cutoff && cutoff.insert_cutoff) {
                      cutoff.insert_cutoff = cutoff.insert_cutoff.substring(0, cutoff.insert_cutoff.lastIndexOf(':'));
                    }
                    return cutoff;
                  })
                  .catch((err) => {
                    this.$store.commit('displaySnackbar', 'ERROR: ' + (err.response === undefined ? 'Unknown error' : err.response.data.error));
                  });
            },
        },
    }
</script>

<style scoped>

  .v-input--switch {
    justify-content: center;
  }

  .delivery-image {
    max-height: 80vh;
    width: 100%;
  }

  .v-list-item {
    user-select: text;
  }

  .signBy{
    background-color: #64b5f6;
    border-radius:3px;
    width: 100%;
    height: 100%;
  }
  .select-status{
    padding-left: 0
  }

</style>




// WEBPACK FOOTER //
// src/components/pages/Delivery/Search/DeliveryInfoDisplayer.vue